import { render, staticRenderFns } from "./PlayGame.vue?vue&type=template&id=7af180ac&"
import script from "./PlayGame.vue?vue&type=script&lang=js&"
export * from "./PlayGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports